import React from 'react';
import GarageGothicBold from '../assets/fonts/GarageGothic-Bold.otf';

const fontString = `
@font-face {
  font-family: GarageGothic;
  font-weight: 600;
  src: url(${GarageGothicBold}) format('opentype');
}
`;

export default () => <style dangerouslySetInnerHTML={{ __html: fontString }} />;



// WEBPACK FOOTER //
// ./src/components/font-loader.js